import { Utils } from "../utilities/Utils";
import { IDocument, Document } from "@/model/Document";
import { mapData } from '@/utilities/DataMapping';

export interface IEmployee {
    id: number;
    guid: string;
    contractorID: number;
    contactNumber: string;
    forename: string;
    surname: string;
    hasSentinelCard: number;
    sentinelID: string;
    appPin: number;
    deactivated: boolean;
    created: Date;
    createdByUserID: number;
    lastUpdated: Date;
    lastUpdatedByUserID: number;
    email: string;
    bookingCount: number;
    currentBookingID: number;
    futureBookings: number;
    canDelete: boolean;
    isRegistered: boolean;
    isActive: boolean;
    address1: string;
    address2: string;
    address3: string ;
    town: string;
    postCode: string;
    lastAuthenticatedOnMobile: Date;
    image: IDocument;
    mobileActionCount: number;
}

export class Employee implements IEmployee {

    constructor(data?: IEmployee) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IEmployee) {
        mapData(data, {
            root: () => this,
            image: () => new Document()
        });
    }

    id: number = 0;
    guid: string = Utils.emptyGuidValue;
    contractorID: number = 0;
    contactNumber: string = "";
    forename: string = "";
    surname: string = "";
    fullName: string = "";
    hasSentinelCard: number = 0;
    sentinelID: string = "";
    appPin: number = 0;
    deactivated: boolean = false;
    created: Date = new Date(Utils.emptyDateValue);
    createdByUserID: number = 0;
    lastUpdated: Date = new Date(Utils.emptyDateValue);
    lastUpdatedByUserID: number = 0;
    email: string = "";
    bookingCount: number = 0;
    currentBookingID: number = 0;
    futureBookings: number = 0;
    canDelete: boolean = false;
    isRegistered: boolean = false;
    isActive: boolean = false;
    address1: string = "";
    address2: string = "";
    address3: string = "";
    town: string = "";
    postCode: string = "";
    lastAuthenticatedOnMobile: Date = new Date(Utils.emptyDateValue);
    image: Document = new Document();
    mobileActionCount: number = 0;

    get isNew() {
        return Utils.isEmptyId(this.id);
    }

    get fullname() {
        return this.forename + ' ' + this.surname;
    }

    get searchDetail() {
        return this.fullname + ', ' + this.sentinelID + ', ' + this.contactNumber;
    }

    get registeredColour() {
        return this.isRegistered ? "black" : "red";
    }
}